// extracted by mini-css-extract-plugin
module.exports = {"certificateWrapper":"WallOfFame_certificateWrapper__1Dlwj","frame":"WallOfFame_frame__3fKAK"};